// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2KiXL","row":"Node_row__1Ayi1","label":"Node_label__2thBY","footer":"Node_footer__3K2AR"};